import { render } from "./CompletarCadastroPF.vue?vue&type=template&id=d16b9cfe&scoped=true"
import script from "./CompletarCadastroPF.vue?vue&type=script&lang=js"
export * from "./CompletarCadastroPF.vue?vue&type=script&lang=js"

import "./CompletarCadastroPF.vue?vue&type=style&index=0&id=d16b9cfe&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d16b9cfe"]])

export default __exports__